import React from 'react';

class PaymentsDashboard extends React.Component {
}

export default PaymentsDashboard;
